import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { FileUp, Clock, ArrowRight } from "lucide-react";

// BULK UPLOAD + WAITING DATAPLATES — side by side in Catch-up tools, where he set them.
export const BulkUploadCard = ({ canManage }) => {
  const [waiting, setWaiting] = useState(null);
  useEffect(() => {
    if (canManage) api.get("/dataplates/waiting").then(({ data }) => setWaiting(data.total)).catch(() => {});
  }, [canManage]);
  return (
    <section data-testid="tool-bulk-upload" className="rounded-xl border-2 border-[#1F1F1F] bg-white overflow-hidden">
      <div className="bg-[#1F1F1F] text-white px-4 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <FileUp className="w-5 h-5 shrink-0" />
          <h2 className="font-display text-lg font-bold truncate">Bulk upload — build sheets &amp; dataplates</h2>
        </div>
        <span data-testid="bulk-upload-state" className="text-[10px] font-mono uppercase tracking-widest bg-emerald-700 px-2 py-1 rounded shrink-0">PDFs + Freightliner Excel · review first</span>
      </div>
      <div className="p-4 space-y-3">
        <p className="text-sm text-slate-700">
          Drop many PDFs — and Freightliner dealer sheets (.xlsx, .xls or .csv) — at once. A build sheet goes on a truck <b>only on one exact, full VIN</b>; a
          Cummins dataplate (QuickServe or parts.cummins.com) is suggested by its VIN or engine serial and <b>you choose the truck or the engine part</b>.
          Nothing is saved until you press Save on that file, and every file undoes on its own.
        </p>
        {canManage ? (
          <div className="grid sm:grid-cols-2 gap-2">
            <Link to="/bulk-upload" data-testid="open-bulk-upload"
              className="flex items-center gap-2 rounded-lg bg-[#B01E28] hover:bg-[#8f1820] text-white px-4 h-12 font-bold text-sm transition-colors">
              <FileUp className="w-4 h-4" />Open Bulk Upload<ArrowRight className="w-4 h-4 ml-auto" />
            </Link>
            <Link to="/dataplates/waiting" data-testid="open-waiting-dataplates"
              className="flex items-center gap-2 rounded-lg border-2 border-slate-300 hover:border-[#1F1F1F] px-4 h-12 font-bold text-sm text-slate-800 transition-colors">
              <Clock className="w-4 h-4 text-sky-700" />Waiting Dataplates
              {waiting !== null && <span data-testid="waiting-dataplates-count" className="ml-auto rounded-md bg-sky-100 text-sky-800 px-2 py-0.5 text-xs font-mono">{waiting}</span>}
            </Link>
          </div>
        ) : (
          <p data-testid="bulk-upload-no-permission" className="text-sm text-slate-500">You need the manage-trucks permission to use these.</p>
        )}
      </div>
    </section>
  );
};
